var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
import { jsx as _jsx, jsxs as _jsxs, Fragment as _Fragment } from "react/jsx-runtime";
import Cell from './Cell';
var PreviewCells = function (_a) {
    var title = _a.title;
    var textMapper = ['actions', 'range', 'ev', 'equity', 'twoPlayers'];
    var nameMapper = {
        actions: 'Strategy cells',
        range: 'Range cells',
        ev: 'EV cells',
        equity: 'Equity cells',
        twoPlayers: 'Range cells for two players',
    };
    return (_jsx(_Fragment, { children: title === 'text' ? (_jsx(_Fragment, { children: textMapper.map(function (item) { return (_jsxs("div", { children: [_jsx("span", __assign({ style: { color: '#77767A' } }, { children: nameMapper[item] })), _jsx(Cell, { type: item.includes('twoPlayers') ? 'range' : item, isTwoPlayers: item.includes('twoPlayers') })] }, item)); }) })) : (_jsx(Cell, { type: title })) }));
};
export default PreviewCells;
